export default __webpack_public_path__ + "static/media/chat_pencil.519d0e25.svg";